import { getIsTransportAccessibilityServiceAvailable } from './getIsTransportAccessibilityServiceAvailable';
import { IApplicationState } from '../../types/redux';
import { hasFutureObjects } from '../../utils/map';
import { selectRegularInfrastructure } from '../infrastructure';

/**
 * Видима ли панель сервисов на карте в правом верхнем углу.
 */
export function getIsMapServicesVisible(state: IApplicationState) {
  const isTransportAccessibilityServiceAvailable = getIsTransportAccessibilityServiceAvailable(state);
  const regularInfrastructure = selectRegularInfrastructure(state);

  return isTransportAccessibilityServiceAvailable || hasFutureObjects(regularInfrastructure);
}
